<template>
  <div class="heatmap_info" ref="heatmapInfo" :class="device">
    <div class="header">
      <i class="icon icon--logo"></i>
      <div class="created">{{ $t('heatmap.created') }}: {{ date }}</div>
    </div>
    <div class="meta">
      <div class="title">{{ applyData.pageName }}</div>
      <div class="url">{{ heatmapUrl }}</div>
    </div>
    <ul class="info-data">
<!--      <li>-->
<!--        <div class="label" v-html="$t('timezone.dashboard.info')"></div>-->
<!--        <div class="info-content">-->
<!--          <span>{{applyData.timezoneName}}</span>-->
<!--        </div>-->
<!--      </li>-->
      <li>
        <div class="label" v-html="$t('heatmap.period')"></div>
        <div class="info-content">
          <span v-html="heatmapPeriod"></span>
        </div>
      </li>
      <li>
        <div class="label" v-html="$t('heatmap.device')"></div>
        <div class="info-content">
          <span v-html="heatmapDevice"></span>
          ({{ getDevicePvPercentage(device) | fixed(1) }}%)
        </div>
      </li>
      <li>
        <div class="label" v-html="$t('heatmap.referrer')"></div>
        <div class="info-content">
          <span v-html="heatmapReferrer"></span>
          ({{ getRefererPvPercentage(referer) | fixed(1) }}%)
        </div>
      </li>
      <li>
        <div class="label" v-html="$t('heatmap.userType')"></div>
        <div class="info-content">
          <span v-html="heatmapUserType"></span>
        </div>
      </li>
      <li>
        <div class="label" v-html="$t('heatmap.data')"></div>
        <div class="info-content">
          <span v-html="heatmapData"></span>
        </div>
      </li>
      <li v-if="this.eventType === 'stream'">
        <div class="label">{{ $t('heatmap.pv') }}</div>
        <div class="info-content">
          <span v-html="heatmapPv"></span>
        </div>
      </li>
      <li v-if="heatmapSegments.length">
        <div class="label" v-html="$t('heatmap.segments')"></div>
        <ul :class="['info-content', 'item-count--' + heatmapSegments.length]">
          <li v-for="segment of heatmapSegments" v-html="segment" v-bind:key="segment"></li>
        </ul>
      </li>
      <li v-if="this.eventType !== 'stream'">
        <div class="label">{{ $t('heatmap.pv') }}</div>
        <div class="info-content">
          <span v-html="heatmapPv"></span>
        </div>
      </li>
      <li v-if="this.freqPv && this.freqPv.length !== 0">
        <div class="label" v-html="$t('heatmap.frequency')"></div>
        <div class="info-content">
          <span v-html="heatmapFrequency"></span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import store from '@/store'
import { getOffset, getPercentage, utcToLocalTimezone } from '@/libs/utils'
export default {
  name: 'HeatmapInfo',
  props: [
    'infoData',
    'referer',
    'device',
    'eventType',
    'eventSource',
    'heatmapType',
    'applyData',
    'metric',
    'pathData',
    'ctaData',
    'ctaReportData',
    'abData',
    'freqTotalPv'
  ],
  computed: {
    timezone () {
      return getOffset(this.applyData.timezoneName)
    },
    heatmapUrl () {
      return location.protocol + '//' + location.hostname + '/report/' + this.applyData._id
    },
    heatmapPeriod () {
      if (this.timeSeriesData) {
        if (this.timeSeriesData.toString().length === 1) {
          return `${this.reportPeriod.start} ~ ${this.reportPeriod.end} 0${this.timeSeriesData}:00 ~ 0${this.timeSeriesData}:59`
        } else {
          return `${this.reportPeriod.start} ~ ${this.reportPeriod.end} ${this.timeSeriesData}:00 ~ ${this.timeSeriesData}:59`
        }
      }
      return this.reportPeriod.start + ' ~ ' + this.reportPeriod.end
    },
    heatmapDevice () {
      return this.$t('common.deviceType.' + this.device)
    },
    heatmapReferrer () {
      if (this.referer === 'all') {
        return this.$t('common.all')
      }
      return this.referer
    },
    heatmapUserType () {
      return this.$t('heatmap.cvr_exit.' + this.eventSource)
    },
    heatmapData () {
      if (this.eventType === 'zoom') {
        return this.$t('heatmap.panel.' + this.eventType + ['In', 'Out'][this.heatmapType])
      }
      if (this.eventType === 'swipe') {
        return this.$t('heatmap.panel.' + this.eventType + ['Vertical', 'Horizontal'][this.heatmapType])
      }
      return this.$t('heatmap.panel.' + this.eventType)
    },
    heatmapSegments () {
      let segmentTexts = []
      if (this.abData) {
        let segmentAB = '<span class="label-segment">' + this.$t('ab.title') + ' : </span>'
        segmentAB += this.$t('ab.report.default.clickPerPv.label.' + (this.abData._id ? 'a' : 'b') + 'Page')
        segmentAB += ' (' + this.abData.pageName + ')'
        segmentTexts.push(segmentAB)
      }
      if (this.ctaData && this.ctaData.coords) {
        let segmentCta = '<span class="label-segment">' + this.$t('cta.title') + ' : </span>'
        if (this.ctaData.except) {
          segmentCta += this.$t('common.unit.unClicked')
        } else {
          segmentCta += this.$t('common.unit.clicked')
        }
        segmentTexts.push(segmentCta)
      }
      if (this.eventType === 'stream') {
        let segmentPath = '<span class="label-segment">' + this.$t('common.path') + ' : </span>'
        let group = this.pathData.group ? this.pathData.group : 'median'
        let conversion = !this.pathData.conversion && this.pathData.conversion !== false
          ? 'all'
          : (this.pathData.conversion ? 'conversion' : 'nonConversion')

        segmentPath += this.$t('reporting.stream.activityStatistics.' + group + 'Group.label')
        segmentPath += ' / '
        segmentPath += this.$t('reporting.stream.conversion.' + conversion + 'Label')
        segmentTexts.push(segmentPath)
      }
      return segmentTexts
    },
    heatmapPv () {
      let addCommas = function (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      let pv = 0
      if (this.ctaData && this.ctaData.coords) {
        if (this.ctaData.except) {
          for (let day of this.ctaReportData.data.ctaData.daily) {
            pv += day.orgPv
          }
          pv = this.metric.pv - pv
        } else {
          for (let day of this.ctaReportData.data.ctaData.daily) {
            pv += day.pv
          }
        }
      } else {
        pv = this.metric.pv
      }

      if (this.freqTotalPv) pv = this.freqTotalPv

      return addCommas(pv) + ' PV'
    },
    heatmapFrequency () {
      let freqData = ''
      let over = '101+'
      this.freqPv.sort((a, b) => {
        if (a === -1) return 1
        if (b === -1) return -1
        return a - b
      });

      const start = this.freqPv[0]
      const end = this.freqPv[this.freqPv.length - 1] === -1 ? over : this.freqPv[this.freqPv.length - 1]
      return `Visits (${start === end ? start : `${start}-${end}`})`
    },
    date () {
      const today = utcToLocalTimezone(new Date(), this.applyData.timezoneName)
      const pad = function (number) {
        if (number < 10) {
          return '0' + number
        }
        return number
      }
      return today.getFullYear() +
        '-' + pad(today.getMonth() + 1) +
        '-' + pad(today.getDate()) +
        ' ' + pad(today.getHours()) +
        ':' + pad(today.getMinutes()) +
        ':' + pad(today.getSeconds())
    },
    reportPeriod () {
      return store.state.reportPeriod
    },
    deviceData () {
      return this.infoData.device[this.device]
    },
    refererData () {
      if (this.deviceData) {
        return this.deviceData.refer
      }
      return null
    },
    timeSeriesData () {
      return JSON.parse(localStorage.getItem('paramData')).timeSeriesData
    },
    freqPv () {
      return JSON.parse(localStorage.getItem('paramData')).freqPv
    }
  },
  mounted () {
    this.$emit('setHeatmapInfoHeight', this.$refs.heatmapInfo.clientHeight)
  },
  methods: {
    getDevicePvPercentage (device) {
      if (!this.infoData.device[device]) {
        return 0
      }
      return getPercentage(this.infoData.device[device].pv, this.infoData.pv)
    },
    getRefererPvPercentage (referer) {
      if (!this.refererData) {
        return 0
      }
      if (referer === 'all') {
        return 100
      }

      const item = this.refererData.find(item => item.refer === referer)

      if (!item) {
        return 0
      }
      return getPercentage(item.pv, this.deviceData.pv)
    }
  }
}
</script>

<style lang="scss" scoped>
  .heatmap_info {
    background: #ffffff;
    color: #2f2f2f;
    line-height: 1.77;
    padding-bottom: 25px;

    .header {
      position: relative;
      background: #c10a43;
      height: 34px;

      .icon--logo {
        margin: 11px 18px;
        height: 12px;
        width: 78px;
        background-size: auto 100%;
      }

      .created {
        position: absolute;
        top: 9px;
        right: 16px;
        white-space: nowrap;
        font-size: 10px;
        color: #ffffff;
        opacity: 0.8;
        text-align: right;
        width: 200px;
      }
    }

    .meta {
      padding: 17px 27px 27px 27px;

      .title {
        margin-right: 200px;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.43;
      }

      .url {
        font-size: 11px;
        color: #666666;
        line-height: 1.18;
        margin-top: 8px;
      }
    }

    &.phone {
      .meta {
        min-height: 56px;

        .title {
          margin-right: 150px;
        }

        .created {
          margin-top: 10px;
          position: static;
        }
      }
    }

    ul.info-data {
      font-size: 13px;
      border-bottom: 1px solid #ebebeb;
      margin: 2px 27px 0 27px;

      li {
        position: relative;
        border-top: 1px solid #ebebeb;
        line-height: 1.54;

        .label {
          position: absolute;
          top: 0;
          left: 0;
          padding: 3px 10px;
          width: 80px;
          color: #8f8f8f;
        }

        div.info-content {
          padding: 3px 10px 3px 95px;
        }

        ul.info-content {
          padding: 3px 10px 3px 100px;

          li {
            border-top: none;
            position: relative;
            margin-left: 7px;

            &::before {
              position: absolute;
              top: 0;
              left: -7px;
              content:"·";
            }
          }

          &.item-count--1 {
            li {
              margin-left: 0;

              &::before {
                display: none;
              }

              & /deep/ .label-segment {
                display: none;
              }
            }
          }
        }
      }
    }
  }
</style>
